import type { PendingShopifyApprovalInfo } from "@intelligems/ig-types/dtos/organization-summaries";

import type { BillingStatusContent } from "./useBillingStatusContent";

const carriesChargeId = (query: string): boolean =>
  new URLSearchParams(query).has("charge_id");

/**
 * The card on screen predates the merchant's answer at Shopify, so it stays
 * hidden from their return (`charge_id` in the query or the fragment) until
 * the billing page takes the return over as an in-flight wait.
 */
export const shouldSuppressShopifyApprovalNudge = ({
  actionType,
  search,
  hash,
  isApprovalReturnInFlight,
}: {
  actionType: BillingStatusContent["actionType"];
  search: string;
  hash: string;
  isApprovalReturnInFlight: boolean;
}): boolean =>
  (actionType === "shopify-approval" || actionType === "shopify-billing") &&
  (isApprovalReturnInFlight ||
    carriesChargeId(search) ||
    carriesChargeId(hash.slice(hash.indexOf("?") + 1)));

export const getShopifyApprovalRedirectId = (
  pendingApproval: PendingShopifyApprovalInfo | undefined
): string | undefined => {
  if (!pendingApproval) {
    return undefined;
  }

  if ("approvalId" in pendingApproval) {
    return pendingApproval.confirmationRedirectAvailable
      ? pendingApproval.approvalId
      : undefined;
  }

  return pendingApproval.commandId;
};
